import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { isEqual } from "lodash";

// Utils
import { Group } from "../../utils/logger";
import { isLocal } from "../../utils/env";

import { Row, Col, Button } from "reactstrap";
import SelectUser from "./Modal.SelectUser";

import { getUsers, storeAdminUser, impersonateUser } from "../../redux/actions/adminActions";

/**
 * The preview modal and associated button handlers
 * @constructor
 */
class ImpersonateUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      is_admin: true,
      users: props.users,
      admin_user: props.admin_user,
      admin_token: props.admin_token,
      current_user: props.current_user,
      current_token: props.current_token,

      // Disable for non-admins
      enabled: false,
    };

    this.LoggerGroup = new Group("Impersonate User", { disable: true });

    this.selectUser = this.selectUser.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const state = {};
    if (!nextProps.users || !isEqual(nextProps.users, prevState.users)) {
      state.users = nextProps.users;
    }
    if (!nextProps.admin_token || !isEqual(nextProps.admin_token, prevState.admin_token)) {
      state.admin_user = nextProps.admin_user;
      state.admin_token = nextProps.admin_token;
    }
    if (!nextProps.current_user || !isEqual(nextProps.current_user, prevState.current_user)) {
      state.current_user = nextProps.current_user;
      state.current_token = nextProps.current_token;
    }

    return state;
  }

  componentDidMount() {
    if (this.state.admin_token && !this.state.users.length) {
      this.props.getUsers();
    }
  }

  selectUser(user) {
    const { current_user } = this.state;

    if (current_user.user_id_bint === user.user_id_bint) {
      return this.LoggerGroup.emit(`Selected current user!`).end();
    }

    this.LoggerGroup.emit("Selected user", { table: user }).end();

    this.props.impersonateUser(user.user_id_bint);
  }

  render() {
    if (!isLocal() || !this.props.enabled) {
      return null;
    }

    const { users, admin_user, admin_token, current_token, current_user } = this.state;

    return (
      <Row style={{ background: "#222a37" }} className="pl-4">
        <Col xs={3} />
        <Col md={{ size: 6 }} className="m-2">
          <SelectUser
            users={users}
            admin_token={admin_token}
            current_token={current_token}
            current_user={current_user}
            selectUser={this.selectUser}
          />
        </Col>

        {current_token !== admin_token && (
          <Col className="my-2">
            <Button onClick={() => this.selectUser(admin_user)}>Restore Session</Button>
          </Col>
        )}
      </Row>
    );
  }
}

ImpersonateUser.propTypes = {
  users: PropTypes.array.isRequired,
  admin_user: PropTypes.object.isRequired,
  admin_token: PropTypes.string.isRequired,
  current_user: PropTypes.object.isRequired,
  current_token: PropTypes.string.isRequired,

  getUsers: PropTypes.func.isRequired,
  storeAdminUser: PropTypes.func.isRequired,
  impersonateUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  errors: state.campaigns.errors,
  loading: state.admin.loading.users,
  admin_user: state.admin.selectedUser,
  admin_token: state.admin.token,
  current_user: state.user.user,
  current_token: state.user.token,
  users: state.admin.users,
  enabled: state.admin.token, // Only enable if admin token is set
});

export default connect(mapStateToProps, {
  storeAdminUser,
  getUsers,
  impersonateUser,
})(ImpersonateUser);
